<template>
	<ion-page>
		<NavigationBar :channelCode="channelCode">
			<template #right>
				<slot name="nav-right"></slot>
			</template>
		</NavigationBar>
		<ion-content :scroll-y="scrollY">
			<slot name="content"></slot>
		</ion-content>
	</ion-page>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'DefaultLayout',
	props: {
		/**
		 * 頂欄中間的頻道代碼，空字串就不顯示
		 */
		channelCode: {
			type: String,
			default: '',
		},
		/**
		 * 內容區是否可整頁捲動，逐字稿頁自己管捲動，傳 false 避免 iOS 邊緣整頁回彈
		 */
		scrollY: {
			type: Boolean,
			default: true,
		},
	},
})
</script>
